import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';
export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  line: {
    flex: 1,
    height: 1,
    backgroundColor: themes.light.gray_blue[6],
  },
  text: {
    marginHorizontal: 10, // Space around the text
    color: themes.light.gray_blue[3],
  },
});
